module.exports = __webpack_public_path__ + "img/image-not-found-hu.26d2c615.jpg";